﻿(function () {
    "use strict";

    let app = angular.module("app");

    app.service("projectAnalysis", ProjectAnalysisService);

    function ProjectAnalysisService() {
        return {
            refreshFromReactWorkareaSummaries: function (itemsContextWorkareaSummaries) {
                return refreshFromReactWorkareaSummaries(itemsContextWorkareaSummaries)
            }
        };
    }

    function refreshFromReactWorkareaSummaries(itemsContextWorkareaSummaries) {
        const summarySum = (summaries, getValue) => summaries.filter(x => !x.isOnHold).reduce((total, x) => total + getValue(x), 0)
        const projectAnalysis = {
            estimated: {
                hours: summarySum(itemsContextWorkareaSummaries, x => x.estimatedHours),
                price: summarySum(itemsContextWorkareaSummaries, x => x.estimatedPrice),
                grossProfit: { amount: summarySum(itemsContextWorkareaSummaries, x => x.estimatedGrossProfit) },
                netProfit: { amount: summarySum(itemsContextWorkareaSummaries, x => x.estimatedNetProfit) }
            },
            actual: {
                hours: summarySum(itemsContextWorkareaSummaries, x => x.actualHours),
                price: summarySum(itemsContextWorkareaSummaries, x => x.standardPrice)
            },
            final: {
                hours: summarySum(itemsContextWorkareaSummaries, x => x.actualHours),
                price: summarySum(itemsContextWorkareaSummaries, x => x.finalPrice),
                grossProfit: { amount: summarySum(itemsContextWorkareaSummaries, x => x.actualGrossProfit) },
                netProfit: { amount: summarySum(itemsContextWorkareaSummaries, x => x.actualNetProfit) }
            },
            workareas: {}
        }
        itemsContextWorkareaSummaries.forEach(summary => {
            projectAnalysis.workareas[summary.workareaId] = {
                estimated: {
                    classes: { 0: { qty: summary.estimatedHours } },
                    price: { final: summary.estimatedPrice }
                },
                actual: {
                    classes: { 0: { qty: summary.actualHours } },
                    price: { standard: summary.standardPrice, final: summary.finalPrice }
                },
                final: {
                    price: { final: summary.finalPrice }
                }
            }
        })

        return projectAnalysis
    }
})();
